import { useDispatch } from "react-redux";
import { cartActions } from "../../store/cartSlice";

const Remove = ({ id, className }) => {
  const dispatch = useDispatch();

  const removeFromCartHandler = (e) => {
    dispatch(cartActions.remove(id));
    e.stopPropagation();
  };

  return (
    <button onClick={removeFromCartHandler} className={className}>
      Remove
    </button>
  );
};

export default Remove;
